import styles from './Architecture.module.scss'

interface ArchiType {
  title: string
  src: string
  alt: string
  skillStack: string[]
  devTime1: number
  devTime2: number
}

const archi: ArchiType[] = [
  {
    title: 'MaaSシステム構築',
    src: '/images/LP/backend/mass-constitution.png',
    alt: 'MaaSシステム構築',
    skillStack: [
      'Amazon Cognito',
      'GraphQL',
      'AWS Lambda',
      'AWS AppSync',
      'Amazon DynamoDB',
      'TypeScript',
      'React Native',
    ],
    devTime1: 3,
    devTime2: 6,
  },
  {
    title: 'ヘルスケアシステム構築',
    src: '/images/LP/backend/healthcare-constitution.png',
    alt: 'ヘルスケアシステム構築',
    skillStack: ['AWS AppSync', 'Amazon DynamoDB', 'AWS Lambda', 'TypeScript', 'React Native'],
    devTime1: 2,
    devTime2: 4,
  },
]

const panel = archi.map(({ title, src, alt, skillStack, devTime1, devTime2 }) => (
  <div className={styles.panel} key={title}>
    <p className={styles.name}>{title}</p>
    <img src={src} alt={alt} />
    <div className={styles.description}>
      <div className={styles.time_wrapper}>
        <p>
          <span className={styles.text_left}>要件策定期間</span>
          <span className={styles.text_right}>{devTime1}ヶ月</span>
        </p>
        <p>
          <span className={styles.text_left}>開発期間</span>
          <span className={styles.text_right}>{devTime2}ヶ月</span>
        </p>
      </div>
      <div className={styles.skill_wrapper}>
        <p className={styles.text_left}>使用技術</p>
        <ul>
          {skillStack.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
))

const Architecture: React.FC = () => {
  return (
    <section className={styles.architecture}>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>アーキテクチャ構築例</h2>
        <div key={1}>{panel}</div>
      </div>
    </section>
  )
}

export default Architecture
